import { useEffect, useState } from "react";
import { supabase } from "@/integrations/supabase/client";

export interface SiteContact {
  phone: string;
  whatsapp: string;
  email: string;
}

const DEFAULTS: SiteContact = {
  phone: "+1-829-629-3263",
  whatsapp: "+18296293263",
  email: "info@expresspuntacana.com",
};

export const telHref = (v: string) => `tel:${v.replace(/[^\d+]/g, "")}`;
export const waHref = (v: string) => `https://wa.me/${v.replace(/\D/g, "")}`;

export function useSiteContact() {
  const [contact, setContact] = useState<SiteContact>(DEFAULTS);

  useEffect(() => {
    let mounted = true;
    (async () => {
      const { data } = await supabase
        .from("settings")
        .select("key,value")
        .in("key", ["company_phone", "company_whatsapp", "company_email"]);
      if (!mounted || !data) return;
      const map = Object.fromEntries(data.map((r: any) => [r.key, r.value]));
      setContact({
        phone: map.company_phone || DEFAULTS.phone,
        whatsapp: map.company_whatsapp || map.company_phone || DEFAULTS.whatsapp,
        email: map.company_email || DEFAULTS.email,
      });
    })();
    return () => {
      mounted = false;
    };
  }, []);

  return contact;
}

export function useSiteLogo() {
  const [logoUrl, setLogoUrl] = useState<string>("");

  useEffect(() => {
    let mounted = true;
    (async () => {
      const { data } = await supabase
        .from("settings")
        .select("value")
        .eq("key", "site_logo_url")
        .maybeSingle();
      if (mounted && data?.value) setLogoUrl(data.value);
    })();
    return () => {
      mounted = false;
    };
  }, []);

  return logoUrl;
}
